// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"4a0f6ce9","298":"1865545a","453":"ca73386a","888":"fa9b2d74"}[chunkId] + ".chunk.js";
};